export var setMeta = function (router, dependencies) { return ({
    onTransitionSuccess: function (toState) {
        var getRouteActionResult = dependencies.getRouteActionResult, i18nextConfig = dependencies.i18nextConfig;
        if (getRouteActionResult) {
            var title = getRouteActionResult(toState.name).title;
            if (title) {
                if (i18nextConfig && i18nextConfig.i18next) {
                    document.title = i18nextConfig.i18next.t(title);
                    return;
                }
                document.title = title;
            }
        }
    },
}); };
